var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false, design: "v3" },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "extra-plan-content" }, [
        _c("div", { staticClass: "header-section" }, [
          _c("div", { staticClass: "icon-wrapper" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("shopping_cart"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.buyExtraChatbot"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("message.selectSessionPackage"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "suggestion-sessions" }, [
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 1000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 1000
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.extraPlanSessionLabel1k")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 5000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 5000
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.extraPlanSessionLabel5k")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 10000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 10000
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.extraPlanSessionLabel10k")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 20000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 20000
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.extraPlanSessionLabel20k")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 50000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 50000
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.extraPlanSessionLabel50k")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 100000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 100000
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.extraPlanSessionLabel100k")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 250000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 250000
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.extraPlanSessionLabel250k")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 1000000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 1000000
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.extraPlanSessionLabel1m")) +
                  "\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-input-section" }, [
          _c("div", { staticClass: "input-container" }, [
            _c("div", { staticClass: "input-wrapper" }, [
              _c("div", { staticClass: "input-icon" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("edit")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-content" },
                [
                  _c("div", { staticClass: "input-label" }, [
                    _vm._v(_vm._s(_vm.$t("message.customSessionAmount"))),
                  ]),
                  _vm._v(" "),
                  _c("a-input-number", {
                    staticClass: "custom-input",
                    attrs: {
                      min: 1,
                      max: 10000000,
                      placeholder: _vm.$t("message.enterAmount"),
                    },
                    model: {
                      value: _vm.sessionCount,
                      callback: function ($$v) {
                        _vm.sessionCount = $$v
                      },
                      expression: "sessionCount",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "arrow-separator" }, [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("arrow_forward"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "price-wrapper" }, [
              _c("div", { staticClass: "price-label" }, [
                _vm._v(_vm._s(_vm.$t("message.totalPrice"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "price-value" },
                [
                  _c("MoneyFormatter", {
                    attrs: {
                      price: _vm.totalPrice,
                      className: _vm.total - _vm.price,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.remainingSessionCount > 0
          ? _c("div", { staticClass: "remaining-warning" }, [
              _c("div", { staticClass: "remaining-warning-icon" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("warning_amber"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "remaining-warning-content" }, [
                _c("div", { staticClass: "remaining-warning-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.existingUsageRights"))),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "remaining-warning-text",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("message.existingSessionRights", {
                        count: _vm.remainingSessionCount.toLocaleString(),
                      })
                    ),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "remaining-priority-list" }, [
                  _c("div", { staticClass: "remaining-priority-item" }, [
                    _c("span", { staticClass: "priority-badge free" }, [
                      _vm._v("1"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "priority-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.freeRights"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "priority-value free" }, [
                      _vm._v(
                        _vm._s(
                          (_vm.features.freeSessionCount || 0).toLocaleString()
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "remaining-priority-item" }, [
                    _c("span", { staticClass: "priority-badge normal" }, [
                      _vm._v("2"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "priority-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.normalPackage"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "priority-value normal" }, [
                      _vm._v(_vm._s(_vm.normalSessionCount.toLocaleString())),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "remaining-priority-item" }, [
                    _c("span", { staticClass: "priority-badge extra" }, [
                      _vm._v("3"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "priority-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.extraPackage"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "priority-value extra" }, [
                      _vm._v(
                        _vm._s(
                          (_vm.features.extraSessionCount || 0).toLocaleString()
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "remaining-warning-note" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.usageOrderNote")) +
                      "\n                "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.sessionCount > 0
          ? _c("div", { staticClass: "warning-message" }, [
              _c("div", { staticClass: "warning-icon" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "warning-content" }, [
                _c("div", { staticClass: "warning-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.importantInfo"))),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "warning-text",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("message.packageEndsInfo", {
                        date: _vm.endOfMonthDate,
                      })
                    ),
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "SupsisButton",
              {
                staticClass: "footer-btn cancel-btn",
                on: { click: _vm.cancel },
              },
              [_vm._v(_vm._s(_vm.$t("common.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                staticClass: "footer-btn primary-btn",
                attrs: { primary: "", disabled: _vm.sessionCount <= 0 },
                on: { click: _vm.confirm },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("check_circle"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("message.buy")))]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }